import { defineComponent as _defineComponent } from 'vue'
import SurveyQuestionnaire from "@/components/surveys/SurveyQuestionnaire.vue"
import FormDialog from "@/components/widgets/common/FormDialog.vue"
import Icon from "@/components/widgets/icons/Icon.vue"
import { computed, onBeforeUnmount } from "vue"
import { ref } from "vue"
import { onMounted } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'TakeAssessmentModal',
  props: {
    url: null,
    surveyId: null,
    timer: null
  },
  emits: ["close"],
  setup(__props: any, { emit }) {

const { url, surveyId, timer } = __props as {
  url?: string | null
  surveyId?: string
  timer?: number // in minutes
}



const totalSeconds = ref((timer || 0) * 60)
const minutes = computed(() => String(Math.floor(totalSeconds.value / 60)).padStart(2, "0"))
const seconds = computed(() => String(totalSeconds.value % 60).padStart(2, "0"))
let interval: any = null

const startCountdown = () => {
  interval = setInterval(updateCountdown, 1000)
}

const updateCountdown = () => {
  if (totalSeconds.value > 0) {
    totalSeconds.value--
  } else {
    clearInterval(interval)
    emit("close")
  }
}

onMounted(() => {
  if (timer) {
    startCountdown()
  }
})

onBeforeUnmount(() => {
  clearInterval(timer)
})



const onClose = () => {
  if (
    window.confirm(
      "Are you sure you want to end test? You can NOT resume it later. Having issues? Refresh the page and try again."
    )
  ) {
    emit("close")
  }
}

return { __sfc: true,totalSeconds, minutes, seconds, interval, startCountdown, updateCountdown, emit, onClose, SurveyQuestionnaire, FormDialog, Icon }
}

})